import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import { content } from "@/lib/content";

const LangContext = createContext(null);

export function LangProvider({ children }) {
  const [lang, setLang] = useState(() => {
    if (typeof window === "undefined") return "it";
    return localStorage.getItem("ef_lang") || "it";
  });

  useEffect(() => {
    if (typeof window !== "undefined") localStorage.setItem("ef_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const t = useMemo(() => content[lang] || content.it, [lang]);

  const value = { lang, setLang, t };
  return <LangContext.Provider value={value}>{children}</LangContext.Provider>;
}

export function useLang() {
  const ctx = useContext(LangContext);
  if (!ctx) throw new Error("useLang must be used within LangProvider");
  return ctx;
}
